import styles from './services.module.scss'

const services = [
    {
        icon: (
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2L2 7l10 5 10-5-10-5z" />
                <path d="M2 17l10 5 10-5" />
                <path d="M2 12l10 5 10-5" />
            </svg>
        ),
        title: 'Web Design',
        desc: 'Beautiful, modern interfaces tailored to your brand — built to impress and convert.',
    },
    {
        icon: (
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="16 18 22 12 16 6" />
                <polyline points="8 6 2 12 8 18" />
            </svg>
        ),
        title: 'Web Development',
        desc: 'Clean, efficient code built for performance, speed, and longevity — on time and on budget.',
    },
    {
        icon: (
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
            </svg>
        ),
        title: 'Support & Maintenance',
        desc: 'Ongoing care to keep your site fast, secure, and up to date — long after launch.',
    },
]

function Services() {
    return (
        <div className={styles.services}>
            <div className={styles.label}>What we do</div>
            <div className={styles.grid}>
                {services.map((s) => (
                    <div className={styles.card} key={s.title}>
                        <div className={styles.icon}>{s.icon}</div>
                        <div className={styles.title}>{s.title}</div>
                        <div className={styles.desc}>{s.desc}</div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Services
